import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Upload, ArrowRight } from 'lucide-react';

interface CtaSectionProps {
  onUploadClick: () => void;
}

export function CtaSection({ onUploadClick }: CtaSectionProps) {
  return (
    <section className="py-16 px-4 md:px-6 bg-primary text-primary-foreground relative overflow-hidden">
      <div className="container text-center relative z-10">
        <h2 className="text-3xl font-bold sm:text-4xl md:text-5xl max-w-3xl mx-auto">
          Start Your AI-Guided Career Journey
        </h2>
        <p className="mt-6 max-w-2xl mx-auto text-primary-foreground/90 md:text-xl">
          Upload your resume or job description once and let our AI platform connect you with the perfect match.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
          <Button 
            size="lg" 
            variant="secondary" 
            className="text-base font-medium shadow"
            onClick={onUploadClick}
          >
            Upload Now
            <Upload className="ml-2 h-5 w-5" />
          </Button>
          <Button 
            size="lg" 
            variant="outline" 
            className="bg-transparent border-white hover:bg-white/10 text-base font-medium"
            asChild
          >
            <Link to="/how-it-works">
              Learn More
              <ArrowRight className="ml-2 h-5 w-5" />
            </Link>
          </Button>
        </div>
        <div className="mt-8 text-primary-foreground/70 text-sm">
          <p>No credit card required. Get started with our free career planning tools.</p>
        </div>
      </div>
    </section>
  );
}